<a [class]="class" href="tel:+{{PHONE_NUMBER}}" (click)="sendEvent()" #ref>
  <ng-content></ng-content>
  <ng-container *ngIf="ref.children.length === 0">
    {{PHONE_NUMBER}}
  </ng-container>
</a>
